import { EditionId, SubjectId } from "@carnegie-learning/common-types";
import { Bundle, CustomActivity, Perform } from "@carnegie-learning/cure-types";
import { Action, createReducer, on } from "@ngrx/store";
import * as fromCartPropertiesActions from "../actions/cart-properties.action";

export interface CartPropertiesState {
    assignCartTabOpen: boolean;
    assignCartOpen: boolean;
    creatingLesson: boolean;
    editingLesson: boolean;
    creatingActivity: boolean;
    editingActivity: boolean;
    containsComposite: boolean;
    lessonFormData: Bundle | null;
    lessonFormValidity: boolean;
    customActivityFormData: CustomActivity | null;
    performActivityFormData: Perform | null;
    activityFormValidity: boolean;
    programSubjectId: SubjectId;
    programEditionId: EditionId;
    assetInUse: boolean;
}

export const initialState: CartPropertiesState = {
    assignCartTabOpen: false,
    assignCartOpen: false,
    creatingLesson: false,
    editingLesson: false,
    creatingActivity: false,
    editingActivity: false,
    containsComposite: false,
    lessonFormData: null,
    lessonFormValidity: false,
    customActivityFormData: null,
    performActivityFormData: null,
    activityFormValidity: false,
    programSubjectId: "",
    programEditionId: "",
    assetInUse: false,
};

const cartClassesListReducer = createReducer(
    initialState,
    on(fromCartPropertiesActions.setAssignCartTabOpen, (state, { payload }) => {
        return {
            ...state,
            assignCartTabOpen: payload,
        };
    }),
    on(fromCartPropertiesActions.setAssignCartOpen, (state, { payload }) => {
        return {
            ...state,
            assignCartOpen: payload,
        };
    }),
    on(fromCartPropertiesActions.setCreatingLesson, (state, { payload }) => {
        return {
            ...state,
            creatingLesson: payload,
        };
    }),
    on(fromCartPropertiesActions.setEditingLesson, (state, { payload }) => {
        return {
            ...state,
            editingLesson: payload,
        };
    }),
    on(fromCartPropertiesActions.setCreatingActivity, (state, { payload }) => {
        return {
            ...state,
            creatingActivity: payload,
        };
    }),
    on(fromCartPropertiesActions.setEditingActivity, (state, { payload }) => {
        return {
            ...state,
            editingActivity: payload,
        };
    }),
    on(fromCartPropertiesActions.setContainsComposite, (state, { payload }) => {
        return {
            ...state,
            containsComposite: payload,
        };
    }),
    on(fromCartPropertiesActions.setLessonFormData, (state, { payload }) => {
        return {
            ...state,
            lessonFormData: payload,
        };
    }),
    on(
        fromCartPropertiesActions.setLessonFormValidity,
        (state, { payload }) => {
            return {
                ...state,
                lessonFormValidity: payload,
            };
        }
    ),
    on(
        fromCartPropertiesActions.setCustomActivityFormData,
        (state, { payload }) => {
            return {
                ...state,
                customActivityFormData: payload,
            };
        }
    ),
    on(
        fromCartPropertiesActions.setPerformActivityFormData,
        (state, { payload }) => {
            return {
                ...state,
                performActivityFormData: payload,
            };
        }
    ),
    on(
        fromCartPropertiesActions.setActivityFormValidity,
        (state, { payload }) => {
            return {
                ...state,
                activityFormValidity: payload,
            };
        }
    ),
    on(fromCartPropertiesActions.setProgramSubjectId, (state, { payload }) => {
        return {
            ...state,
            programSubjectId: payload,
        };
    }),
    on(fromCartPropertiesActions.setProgramEditionId, (state, { payload }) => {
        return {
            ...state,
            programEditionId: payload,
        };
    }),
    on(fromCartPropertiesActions.checkAssetInUseSuccess, (state, { bool }) => {
        return {
            ...state,
            assetInUse: bool,
        };
    })
);

export function reducer(
    state: CartPropertiesState | undefined,
    action: Action
) {
    return cartClassesListReducer(state, action);
}

export const getAssignCartTabOpen = (state: CartPropertiesState) =>
    state.assignCartTabOpen;
export const getAssignCartOpen = (state: CartPropertiesState) =>
    state.assignCartOpen;
export const getCreatingLesson = (state: CartPropertiesState) =>
    state.creatingLesson;
export const getEditingLesson = (state: CartPropertiesState) =>
    state.editingLesson;
export const getCreatingActivity = (state: CartPropertiesState) =>
    state.creatingActivity;
export const getEditingActivity = (state: CartPropertiesState) =>
    state.editingActivity;
export const getContainsComposite = (state: CartPropertiesState) =>
    state.containsComposite;
export const getLessonFormData = (state: CartPropertiesState) =>
    state.lessonFormData;
export const getLessonFormValidity = (state: CartPropertiesState) =>
    state.lessonFormValidity;
export const getCustomActivityFormData = (state: CartPropertiesState) =>
    state.customActivityFormData;
export const getPerformActivityFormData = (state: CartPropertiesState) =>
    state.performActivityFormData;
export const getActivityFormValidity = (state: CartPropertiesState) =>
    state.activityFormValidity;
export const getProgramSubjectId = (state: CartPropertiesState) =>
    state.programSubjectId;
export const getProgramEditionId = (state: CartPropertiesState) =>
    state.programEditionId;
export const getAssetInUse = (state: CartPropertiesState) =>
    state.assetInUse;
